export default {
  UnitCode: "",
  Description: "",
  Active: true,
  UserModified: localStorage.getItem("UserName"),
};
